import { isFinancialTelemetry } from "@/features/giving/privacy";
import * as Sentry from "@sentry/react";

const sentryDsn =
  import.meta.env.VITE_SENTRY_DSN?.trim();

const environment =
  import.meta.env.VITE_APP_ENV?.trim() ||
  import.meta.env.MODE;

const release =
  import.meta.env.VITE_SENTRY_RELEASE?.trim();

export function initializeSentry() {
  if (!sentryDsn) {
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    environment,
    release: release || undefined,

    integrations: [
      Sentry.browserTracingIntegration(),
    ],

    tracesSampleRate: 0.2,

    sendDefaultPii: false,

    beforeBreadcrumb(breadcrumb) {
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      return isFinancialTelemetry(breadcrumb, path) ? null : breadcrumb;
    },
    beforeSendTransaction(event) {
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      return isFinancialTelemetry(event, path) ? null : event;
    },
    beforeSend(event, hint) {
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      if (environment === "development" || isFinancialTelemetry(event, path, hint.originalException)) return null;
      return event;
    },
  });

  Sentry.setTag(
    "service",
    "ministryiq-web",
  );
}

export function setSentryUserContext({
  userId,
  churchId,
  role,
}: {
  userId: string;
  churchId: string;
  role: string;
}) {
  Sentry.setUser({
    id: userId,
  });

  Sentry.setTag(
    "church_id",
    churchId,
  );

  Sentry.setTag(
    "role",
    role,
  );
}

export function clearSentryUserContext() {
  Sentry.setUser(null);

  Sentry.setTag(
    "church_id",
    "anonymous",
  );

  Sentry.setTag(
    "role",
    "anonymous",
  );
}